var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('data-table',{attrs:{"table-ref":"rentalduetable","url":"/report/property/due","fields":_vm.fields,"title":"Tenancy Due","icon":"fa fa-asterisk","search-placeholder":"Site name, Landlord..."}}),_vm._v(" "),_c('events-calendar',{attrs:{"category":"tenancy"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }